/**
 * ระบบคลังเก็บของบัญชี (Account Storage / Kafra System)
 *
 * ผู้เล่นในบัญชีเดียวกันสามารถฝากและถอนไอเทมหรือโกลด์ข้ามตัวละครได้
 * เพื่อช่วยบริหารน้ำหนักสัมภาระและส่งต่อของระหว่างตัวละคร
 */
export const STORAGE_MAX_SLOTS = 100;
export const STORAGE_TEXT = {
    not_logged_in: "ต้องเข้าสู่ระบบบัญชีก่อนจึงจะใช้คลังเก็บของได้",
    too_far: "อยู่ห่างจากผู้ดูแลคลังสมบัติมากเกินไป",
    invalid_item: "ไม่มีไอเทมนี้หรือไม่สามารถฝากได้",
    not_enough_item: "จำนวนไอเทมในตัวไม่เพียงพอ",
    storage_full: "คลังเก็บของเต็มแล้ว (สูงสุด 100 ช่อง)",
    not_enough_gold: "โกลด์ไม่เพียงพอสำหรับทำรายการ",
    invalid_amount: "จำนวนไม่ถูกต้อง",
    inventory_full: "กระเป๋าสัมภาระเต็ม",
    overweight: "น้ำหนักกระเป๋าจะเกินเพดานแบกรับ ไม่สามารถเบิกของได้",
};
/** ค้นหาช่องว่างแรกในคลังเก็บของ (0 ถึง maxSlots - 1) */
export function findFirstFreeStorageSlot(items, maxSlots = STORAGE_MAX_SLOTS) {
    const occupied = new Set(items.map((it) => it.slot));
    for (let s = 0; s < maxSlots; s++) {
        if (!occupied.has(s))
            return s;
    }
    return -1;
}
/** ค้นหาช่องที่เก็บไอเทมชนิดเดียวกันอยู่แล้ว เพื่อรวมกอง */
export function findStorageSlotWithItem(items, itemId) {
    return items.find((it) => it.itemId === itemId);
}
//# sourceMappingURL=storage.js.map